<template>
    <div id="extra-project-documentation">
        <div class="vx-row">
            <div class="vx-col w-full">
                <div class="mb-4 mt-4 w-full">
                    <vs-table stripe :data="relatedContent" noDataText="No se han generado registros">
                        <template slot="header">
                            <h3>Contenido extra</h3>
                            <vs-button @click.stop="popupActivo = true" class="mb-2 mr-2" size="small" color="success">Agregar contenido</vs-button>
                        </template>
                            <template slot="thead">
                            <vs-th class="bold">TIPO</vs-th>
                            <vs-th class="bold">NOMBRE</vs-th>
                            <vs-th class="bold">LINK</vs-th>
                            <vs-th class="bold">ACCIONES</vs-th>
                        </template>

                        <template slot-scope="{data}">
                            <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                                <vs-td :data="data[indextr].content_type">
                                {{ translateContentTypeEnum(tr.content_type) }}
                                </vs-td>

                                <vs-td :data="data[indextr].loan_guarantees_name">
                                {{ tr.name }}
                                </vs-td>

                                <vs-td :data="indextr">
                                {{ tr.link }}
                                </vs-td>

                                <vs-td :data="data[indextr].id">
                                    <vs-button @click="deleteContentRequest(tr)" radius size="small" type="border" icon="delete" color="danger"></vs-button>
                                </vs-td>
                            </vs-tr>
                        </template>
                    </vs-table>
                </div>
            </div>
        </div>

        <vs-popup title="Agregar contenido" :active.sync="popupActivo">
            <div class="vx-row">
                <div class="vx-col">
                    <vx-card title="Nuevo contenido">
                        <p class="mb-2">Define el contenido extra, recuerda que esta información será visible para toda la comunidad.</p>
                        <vs-divider></vs-divider>
                    <!-- TIPO DE CONTENIDO -->
                        <vs-select
                            class="w-full mb-2"
                            v-model.lazy="contentSelected"
                            name="contentSelected"
                            placeholder="Seleccione una opción"
                            label="Tipo de contenido">
                            
                            <vs-select-item
                            :key="index"
                            :value="item.id"
                            :text="item.select_name"
                            v-for="(item,index) in contentType"
                            class="w-full"
                            />
                        </vs-select>
                    <!-- NOMBRE DEL CONTENIDO -->
               
                        <vs-input label="Nombre" class="w-full mb-2" type="text" v-model="contentName"/>

                        <div v-if="contentSelected == 'document'">
                            <input
                                class="m-4"
                                ref="fileInput"
                                id="extra_layout"
                                text="Seleccione el documento"
                                accept="image/png, image/jpeg, application/pdf"
                                fileName="file" 
                                type="file" />
                        </div>
                        
                        <div v-else>
                            <vs-input label="Link" class="w-full mb-2" type="text" v-model="contentLink"/>
                        </div>
                        

                        <div class="flex flex-wrap items-center justify-end">
                            <vs-button type="line" class="mt-4" @click="popupActivo = false, cleanForm()">Cerrar</vs-button>
                            <vs-button class="ml-2 mt-4" @click="saveContentRequest()">Guardar cambios</vs-button>
                        </div>
                    </vx-card>
                </div>
            </div>
        </vs-popup>
    </div>
</template>

<script>
import inputHelper from '@components/mixins/inputHelper';

const contentType = [
    { id: "document", select_name: "Documento" }
    , { id: "external_url", select_name: "Link externo" }
    , { id: "internal_url", select_name: "Link interno" }
];

export default {
    name: "extra-project-documentation",
    props: ["projectId"],
    mixins: [
        inputHelper
    ],
    data() {
        return {
            relatedContent: [],
            contentType: contentType,
            popupActivo: false,
            contentSelected: null,
            currentProjectFinanceId: null,
            itemToDelete: null,
            contentName: null,
            contentLink: null
        }
    },
    mounted() {
        this.getCurrentProjectContent();
    },
    methods: {
        cleanForm(){
            this.contentSelected = null;
            this.itemToDelete = null;
            this.contentName = null;
            this.contentLink = null;
            document.getElementById('extra_layout').value= null;
        },
        async getCurrentProjectContent()
        {
            try {
                const res = await axios.get(`/api/get/project-related-content/by-project/${this.projectId}`)
                this.relatedContent = res.data;
            } catch (error) {
                console.error(error);
            }
        },

        saveContentRequest(item) {
            this.currentProjectFinanceId = item;
            if(this.contentSelected != "document") {
                if(this.contentSelected == null || this.contentName == null || this.contentLink == null){
                    this.missingFieldsNotif();
                    return;
                }
            } else {
                if(this.contentSelected == null || this.contentName == null){
                    this.missingFieldsNotif();
                    return;
                }
            }
            this.$vs.dialog({
                type: 'alert',
                color: 'warning',
                title: "Nueva garantía",
                text: "Se agregará una nueva garantía para el crédito ¿Quiere continuar?",
                acceptText: "Aceptar",
                cancelText: 'Cancelar',
                accept: this.contentSelected != "document" ? this.doRequestSave : this.doDocumentRequestSave
            });
        },
        async doDocumentRequestSave()
        {
            try {
                const doc = document.getElementById('extra_layout');
                if(doc.files.length === 0){
                    this.errorNotif("Aviso", 'Por favor, carga el documento que será contenido para el proyecto.', 4000);
                    return;
                }
                this.showLoading(true);
    
                let data = new FormData();
                data.append("file", doc.files[0]);
                data.append("project_id", this.projectId);
                data.append("name", this.contentName);
                data.append("content_type", this.contentSelected);
    
                await axios.post(`/api/post/project-related-content/new`, data);
    
                this.getCurrentProjectContent();
                this.cleanForm();
                this.showLoading(false);
            } catch (error) {
                this.showLoading(false);
            }
        },
        async doRequestSave() {
            try {
                this.showLoading(true);
                const payload = {
                    project_id: this.projectId
                    , content_type: this.contentSelected 
                    , name: this.contentName 
                    , link: this.contentLink
                }
                await axios.post(`/api/post/project-related-content/new`, payload);
                this.getCurrentProjectContent();
                this.cleanForm();
                this.showLoading(false);
            } catch (error) {
                this.showLoading(false);
            }
        },

        deleteContentRequest(item) {
            this.itemToDelete = item;
            this.$vs.dialog({
                type: 'alert',
                color: 'danger',
                title: "Borrar contenido",
                text: "Se eliminará el contenido adicional para el crédito ¿Deseas continuar?",
                acceptText: "Aceptar",
                cancelText: 'Cancelar',
                accept: this.doRequestDelete
            });
        },
        async doRequestDelete() {
            try {
                this.showLoading(true);
                const payload = {
                    content_id: this.itemToDelete.id
                }
                await axios.post(`/api/delete/project-related-content`, payload);
                this.getCurrentProjectContent();
                this.showLoading(false);
            } catch (error) {
                this.showLoading(false);
            }
        },
        translateContentTypeEnum(type) {
            const types = {
                "document" : "Documentos",
                "external_url" : "Link externo",
                "internal_url" : "Link interno",
                "default" :	"No definido",
            };

            return (types[type] || types["default"]);
        }
    }

}
</script>

<style>
    .con-vs-dialog {
        z-index: 9999999 !important;
    }
</style>